<template>
  <div>
    <div class="field" :style="{marginTop: '40px'}">
      <div class="control">
        <label class="label">ວັນທີຮຽກເກັບເງິນ</label>
        <vuejs-datepicker
            v-model="payDate"
            input-class="input"
            format="d/M/yyyy"
            name="valid_date"
            v-validate="'required'"
        >
        </vuejs-datepicker>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">ເງິນໂອນເກີນຄັ້ງກ່ອນ</label>
        <input
            class="input"
            v-model="debt_last_time"
            placeholder="ຈຳນວນເງິນໂອນເກີນຄັ້ງກ່ອນ..."
        >
      </div>
    </div>
    <div class="field">
      <div class="control">
        <label class="label">ຄ່າທຳນຽມໂອນ</label>
        <input
            class="input"
            v-model="transfer_fee"
            placeholder="ຄ່າທຳນຽມໂອນ..."
        >
      </div>
    </div>
    <vs-button
        ref="button"
        flat @click="ExportsExcel_By_Total()"
        class="form-btn-loading"
        :loading="loading"
    >
      Export Excel
    </vs-button>
  </div>
</template>

<script>
import vuejsDatepicker from 'vuejs-datepicker';
import {FormatDateTimeBeforeSendToServer, FormatDate} from '@/Helpers/Format';

export default {
  props: [
    'invoiceId',
    'branchType'
  ],
  components: {
    vuejsDatepicker
  },

  data: () => ({
    payDate: new Date(),
    loading: false,
    debt_last_time: 0,
    transfer_fee: 1000,
    la_branch: {
      'branch': 'ສາຂາຫຼັກ',
      'franchise': 'ສາຂາແຟນຊາຍ',
    }
  }),
  methods: {
    ExportsExcel_By_Total() {
      const invoiceId = this.invoiceId.map(item => item.id);
      this.loading = true;
      this.$http.post('print-cod-' + this.branchType.split('_')[0] + '-invoice-total', {
            invoices: invoiceId,
            date: FormatDateTimeBeforeSendToServer(this.payDate),
            debt_last_time: this.debt_last_time,
            transfer_fee: this.transfer_fee,
            type: this.branchType,
            invoiceType: this.invoiceType
          },
          {responseType: 'blob'}
      ).then((response) => {
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        fileLink.setAttribute('download', 'Invoice COD ' + this.la_branch[this.branchType.split('_')[0]] + ' ແບບລວມ ວັນທີ ' + FormatDate(this.payDate) + '.xlsx');
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        this.loading = false;
        this.$emit('close');
        this.$emit('success');
      }).catch(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  &:hover {
    color: $white !important;
  }
}
</style>
